import { useContactDataStepForm } from './ContactDataStep.hooks';
import InputField from 'components/Form/InputField/InputField';
import Flex from 'style-utils/components/Flex';
import RegistrationFormSkeleton from 'Layout/Registration/components/RegistrationFormSkeleton';
import {
  confirmEmailField,
  emailField,
  flagNewsletterField,
  flagProfileField,
  phoneNumberField,
  phonePrefixField,
} from './ContactDataStep.config';
import { filterEmailNonFrenchCharacters } from 'utils/validation/filterNonFrenchCharacters';
import { transformLengthError } from 'utils/validation/length';
import { filterPhoneNumber } from 'utils/validation/phone';
import CheckboxSecondaryVariant from 'components/Form/CheckboxSecondaryVariant/CheckboxSecondaryVariant';
import { Span } from 'components/Typography';
import FullPageLoader from 'components/Loader/components/FullpageLoader';
import { useTrackViewOnce } from 'utils/hooks/analytics';
import { usePreFilledPdv } from 'pages/SignupPDV/SignupPDV.hooks';

const ContactDataStep = () => {
  const { methods, isLoading, handleSubmit, touchFieldIfAutoFilled } =
    useContactDataStepForm();

  const { isEmailPreFilled, isConfirmEmailPreFilled } = usePreFilledPdv();

  useTrackViewOnce(
    {
      pagename: 'signup:reg-step1',
    },
    true,
  );

  return (
    <RegistrationFormSkeleton
      stepHeading="contactDataStep.pageTitle"
      methods={methods}
      isDisabled={isLoading}
      handleSubmit={handleSubmit}
    >
      <FullPageLoader isVisible={isLoading} />
      <Flex flexDirection="column" gap="1.2rem">
        <InputField
          label="contactDataStep.emailField"
          name={emailField}
          filterValue={filterEmailNonFrenchCharacters}
          transformError={transformLengthError}
          onChangeCallback={touchFieldIfAutoFilled}
          feedbackOnlyIfMessage
          disabled={isEmailPreFilled}
        />
        <InputField
          label="contactDataStep.confirmEmailField"
          name={confirmEmailField}
          onChangeCallback={touchFieldIfAutoFilled}
          disabled={isConfirmEmailPreFilled}
          feedbackOnlyIfMessage
        />
        <Flex gap="1.3rem">
          <Flex w="7.7rem">
            <InputField
              label="contactDataStep.phonePrefixField"
              name={phonePrefixField}
              disabled
              feedbackOnlyIfMessage
            />
          </Flex>
          <InputField
            label="contactDataStep.phoneField"
            name={phoneNumberField}
            filterValue={filterPhoneNumber}
            transformError={transformLengthError}
            onChangeCallback={touchFieldIfAutoFilled}
            feedbackOnlyIfMessage
          />
        </Flex>
      </Flex>
      <Flex flexDirection="column" m="2.2rem 0 0" gap="1.5rem">
        <CheckboxSecondaryVariant
          name={flagProfileField}
          label="contactDataStep.flagProfileField"
        />
        <CheckboxSecondaryVariant
          name={flagNewsletterField}
          label="contactDataStep.flagNewsletterField"
        />
        <Span
          fontFamily="Muli"
          fontSize="1.2rem"
          lineHeight="1.6rem"
          fontWeight={400}
          i18nKey={'contactDataStep.revokeConsentNotice'}
        />
      </Flex>
    </RegistrationFormSkeleton>
  );
};
export default ContactDataStep;
